import React from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import BranchManagerDashboard from "../../pages/dashboard/BranchManagerDashboard";

const BranchManagerRoutes = () => {


  return (
    <Routes>
      <Route path="/dashboard" element={<BranchManagerDashboard />} />
    </Routes>
  );
};

export default BranchManagerRoutes;
